import { Button } from "@jmc/solid-design-system/src/components/atoms/Button/Button";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import React from "react";
import { useTranslation } from "react-i18next";

import { login } from "../../api/auth";
import style from "./style.module.scss";

export const RestrictedPageContent: React.FunctionComponent = () => {
    const { t } = useTranslation();

    const goToLoginPage = (): void => {
        login(process.env.GATSBY_COUNTRY_CODE);
    };

    return (
        <div className={style.containerSection}>
            <Typography variant="h3" color="title" weight="500">
                {t("You are not allowed to see this page", { ns: "login" })}
            </Typography>
            <div className={style.restrictedErrorCode}>
                <Typography variant="span" color="light" font="text" size={"s"}>
                    {`${t("Error code", { ns: "login" })}: 403`}
                </Typography>
            </div>
            <Typography color="dark" font="text">
                {t(
                    "login:The content of this page is intended for registered users only. To see the content, please login.",
                )}
            </Typography>
            <div className={style.actionButton}>
                <Button onClick={() => goToLoginPage()}>{t("Login to continue", { ns: "login" })}</Button>
            </div>
        </div>
    );
};

export default RestrictedPageContent;
